// import {gsap} from "gsap";
import Glightbox from "glightbox";

function initSliders() {

    const swiper = new Swiper('.homepageSlider', {
        speed: 400,
        spaceBetween: 100,
    });

    const propertySlider = document.querySelectorAll(".propertySlider");

    if(propertySlider) {
        propertySlider.forEach((slider => {

            slider.next = document.querySelector("#swiper_next_" + slider.dataset.swiperid);
            slider.prev = document.querySelector("#swiper_prev_" + slider.dataset.swiperid);

            new Swiper(slider, {
                observer: true,
                observeParents: true,
                speed: 400,
                loop: false,
                navigation: {
                    nextEl: slider.next,
                    prevEl: slider.prev
                },
                spaceBetween: 45,
                slidesPerView: 1,
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    }
                }
            });
        }));
    }
}

let previousScrollPosition = 0,
    lightboxOpened = false;

function initLightbox() {

    const lightbox = Glightbox({
        selector: '.glightbox',
        loop: true
    })

    lightbox.on("open", () => {

        lightboxOpened = {
            instance: lightbox,
            element: document.getElementById("glightbox-body")
        };
    });

    lightbox.on("close", () => {
        lightboxOpened = null;
    });

    initGlightboxScrollEvent()

}

function initGlightboxScrollEvent() {

    window.addEventListener('wheel', (event) => {

        if(!lightboxOpened.element) {
            return;
        }

        const now = Date.now();

        if (now - previousScrollPosition < 500) {
            return; // Prevent rapid scrolling
        }

        previousScrollPosition = now;

        if (event.deltaY < 0) {
            if(lightboxOpened.element) {
                lightboxOpened.instance.prevSlide();
            }
        } else {
            if(lightboxOpened.element) {
                lightboxOpened.instance.nextSlide();
            }
        }
    });
}

function initMenu() {

    const MENU_TOGGLER = document.querySelector('#menuToggler'),
          MOBILE_MENU = document.querySelector('#mobileMenu'),
          SUBMENU_TOGGLERS = document.querySelectorAll(".header__mobileNav .nav__item__submenuToggler");

    if(MENU_TOGGLER) {

        const MENU_TOGGLER_LINES = MENU_TOGGLER.querySelectorAll(".header__menuLine");

        MENU_TOGGLER.addEventListener("click", (e) => {

            e.preventDefault();

            document.body.classList.toggle("overflow-hidden");

            console.dir(MENU_TOGGLER_LINES);


            if(MENU_TOGGLER.classList.contains("active")) {

                gsap.to(MENU_TOGGLER_LINES[0], {rotate: "0deg", top: 0, duration: 0.3})
                gsap.to(MENU_TOGGLER_LINES[1], {opacity: 1, duration: 0.3})
                gsap.to(MENU_TOGGLER_LINES[2], {rotate: "0deg", top: "100%", duration: 0.3})

                // timeline([
                //     [animate(, {rotate: "0deg", top: "0"}, {duration: 0.3})],
                //     [animate(MENU_TOGGLER_LINES[1], {opacity: 1}, {duration: 0.3})],
                //     [animate(MENU_TOGGLER_LINES[2], {rotate: "0deg", top: "100%"}, {duration: 0.3})]
                // ])

                gsap.to(MOBILE_MENU, {visibility: "hidden", opacity: 0, duration: 0.3})

                // animate(MOBILE_MENU, {visibility: "hidden", opacity: 0}, {duration: 0.3});
            } else {
                // timeline([
                //     animate(MENU_TOGGLER_LINES[2], {rotate: "0", top: "100%"}, {duration: 0.3, ease: "easeInOut"}),
                //     animate(MENU_TOGGLER_LINES[1], {opacity: 1}, {duration: 0.3, ease: "easeInOut"}),
                //     animate(MENU_TOGGLER_LINES[0], {rotate: "0", top: "0"}, {duration: 0.3, ease: "easeInOut"})
                // ])

                gsap.to(MENU_TOGGLER_LINES[0], {rotate: "45deg", top: "50%", duration: 0.3});
                gsap.to(MENU_TOGGLER_LINES[2], {rotate: "-45deg", top: "50%", duration: 0.3});
                gsap.to(MENU_TOGGLER_LINES[1], {opacity: 0, duration: 0.3})

                /*timeline([
                    [animate(MENU_TOGGLER_LINES[0], {rotate: "45deg", top: "50%"}, {duration: 0.3})],
                    [animate(MENU_TOGGLER_LINES[2], {rotate: "-45deg", top: "50%"}, {duration: 0.3})],
                    [animate(MENU_TOGGLER_LINES[1], {opacity: 0}, {duration: 0.3})],
                ])*/

                gsap.to(MOBILE_MENU, {visibility: "visible", opacity: 1, duration: 0.3})
            }

            MENU_TOGGLER.classList.toggle("active");
        });
    }

    if(SUBMENU_TOGGLERS) {

        SUBMENU_TOGGLERS.forEach((toggler) => {

            toggler.mainLink = toggler.closest(".menu-item");

            toggler.addEventListener("click", (e) => {
                e.preventDefault();

                if(toggler.mainLink) {
                    toggler.mainLink.classList.toggle("-opened");
                }
            });
        });
    }

}

function initWPCF7() {

    var wpcf7Elm = document.querySelector( '.wpcf7' );

    if(wpcf7Elm) {
        wpcf7Elm.addEventListener('wpcf7submit', function (event) {

            let notyf = new Notyf();

            switch (event.detail.status) {
                case 'mail_sent':
                    notyf.success(event.detail.apiResponse.message);
                    break;
                case 'validation_error':
                    notyf.error(event.detail.apiResponse.message);
                    break;
                default:
                    notyf.error(event.detail.apiResponse.message);
            }

        }, false);
    }
}

function init() {

    const SHOW_MORE = Array.from(document.getElementsByClassName("showMore"))

    SHOW_MORE.forEach((more) => {
        more.addEventListener("click", function(e){
            e.preventDefault();
            more.classList.toggle("-active")
        })
    });
}

function initModals() {

    const MODAL_TRIGGERS = document.querySelectorAll(".toggleModal");

    // let lastModal = null;

    if(MODAL_TRIGGERS) {
        MODAL_TRIGGERS.forEach((trigger) => {

            if(trigger.hash) {
                trigger.modal = document.getElementById(trigger.hash.replace("#", ""))

                trigger.modal.closeButton = trigger.modal.querySelector(".modal__close");

                if(trigger.modal.closeButton) {
                    trigger.modal.closeButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        trigger.modal.classList.remove("-opened");
                        // lastModal = null;
                    })
                }

            }

            trigger.addEventListener("click", (e) => {

                e.preventDefault();

                // if(lastModal && lastModal !== trigger.modal) {
                //     lastModal.closeButton.dispatchEvent(new MouseEvent("click"));
                //     lastModal = null;
                // }

                if(trigger.modal) {
                    trigger.modal.classList.toggle("-opened");
                }

                // lastModal = trigger.modal.classList.contains("-opened") ? trigger.modal : null;

            });

        });
    }
}

(function() {
    init();
    initModals();
    initMenu();
    initSliders();
    initWPCF7();
    initLightbox();
})();

